import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Write from "../pages/write/page";
import PostDetail from "../pages/post/page";
import Profile from "../pages/profile/page";
import ExchangeHistory from "../pages/profile/exchanges/page";
import CommentHistory from "../pages/profile/comments/page";
import LikeHistory from "../pages/profile/likes/page";
import NoticesPage from "../pages/notices/page";
import AboutPage from "../pages/about/page";
import VerifiedPage from "../pages/verified/page";
import VerificationPage from "../pages/verification/page";
import VerificationReportPage from "../pages/verification/report/page";
import CommunityPage from "../pages/community/page";
import CommunityCategoryPage from "../pages/community/category/page";
import GuidePage from "../pages/guide/page";
import GuideCategoryPage from "../pages/guide/category/page";
import LevelGuidePage from "../pages/level-guide/page";
import SportsPage from "../pages/sports/page";
import SportsCategoryPage from "../pages/sports/category/page";
import SportsArticleDetail from "../pages/sports/article/page";
import FAQPage from "../pages/faq/page";
import SupportPage from "../pages/support/page";
import StandingsPage from "../pages/standings/page";
import AdminLayout from "../pages/admin/layout/AdminLayout";
import AdminPointsPage from "../pages/admin/points/page";
import AdminMembersPage from "../pages/admin/members/page";
import AdminPostsPage from "../pages/admin/posts/page";
import AdminBannersPage from "../pages/admin/banners/page";
import AdminNoticesPage from "../pages/admin/notices/page";
import AdminVerifiedPage from "../pages/admin/verified/page";
import AdminGiftsPage from "../pages/admin/gifts/page";
import AdminLogoPage from "../pages/admin/logo/page";
import AdminSettingsPage from "../pages/admin/settings/page";
import VerifiedDetailPage from "../pages/verified/detail/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/write", element: <Write /> },
  { path: "/post/:id", element: <PostDetail /> },
  { path: "/profile", element: <Profile /> },
  { path: "/profile/comments", element: <CommentHistory /> },
  { path: "/profile/likes", element: <LikeHistory /> },
  { path: "/profile/:userId", element: <Profile /> },
  { path: "/profile/:userId/comments", element: <CommentHistory /> },
  { path: "/profile/:userId/likes", element: <LikeHistory /> },
  { path: "/profile/exchanges", element: <ExchangeHistory /> },
  { path: "/notices", element: <NoticesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/verified", element: <VerifiedPage /> },
  { path: "/verified/:id", element: <VerifiedDetailPage /> },
  { path: "/verification", element: <VerificationPage /> },
  { path: "/verification/report", element: <VerificationReportPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/community/:category", element: <CommunityCategoryPage /> },
  { path: "/guide", element: <GuidePage /> },
  { path: "/guide/:tab", element: <GuideCategoryPage /> },
  { path: "/level-guide", element: <LevelGuidePage /> },
  { path: "/sports", element: <SportsPage /> },
  { path: "/sports/article/:id", element: <SportsArticleDetail /> },
  { path: "/sports/:sport", element: <SportsCategoryPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/support", element: <SupportPage /> },
  { path: "/standings", element: <StandingsPage /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminMembersPage /> },
      { path: "members", element: <AdminMembersPage /> },
      { path: "posts", element: <AdminPostsPage /> },
      { path: "notices", element: <AdminNoticesPage /> },
      { path: "banners", element: <AdminBannersPage /> },
      { path: "verified", element: <AdminVerifiedPage /> },
      { path: "points", element: <AdminPointsPage /> },
      { path: "gifts", element: <AdminGiftsPage /> },
      { path: "logo", element: <AdminLogoPage /> },
      { path: "settings", element: <AdminSettingsPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;